/// <reference path="Definitions/custom.d.ts" />
/// <reference path="Definitions/google.maps.d.ts" />
/// <reference path="Definitions/underscore.d.ts" />

import * as $ajax from './_ajax'
import * as $modal from './_modal'
import * as $maps from './_maps'

var locationsThis
var locationsOther
var mapSide
var mapUnder

var ownerId: number = 0
var pageName: string = null
var pagePrefix: string = null
var mapSideId: string = null
var mapUnderId: string = null
let pp = null

export function init($pageName, $pagePrefix, $locationsThis, $locationsOther, $ownerId): void {
    locationsThis = $locationsThis
    locationsOther = $locationsOther
    pageName = $pageName
    pagePrefix = $pagePrefix
    ownerId = $ownerId

    mapSideId = pageName + '-' + pagePrefix + '-map-side'
    mapUnderId = pageName + '-' + pagePrefix + '-map-under'

    pp = '.' + pageName + ' .' + pagePrefix

    $(pp + '-map-side-show-btn').click(function () {
        $(pp + '-map-side-box').show()
        $(pp + '-map-side-box-btn').hide()
        initMap(mapSide, mapSideId)
    })

    $(pp + '-map-under-show-btn').click(function () {
        $(pp + '-map-under-box').show()
        $(pp + '-map-under-box-btn').hide()
        initMap(mapUnder, mapUnderId)
    })

    $(pp + '-map-under-show-btn').click(function () {
        showMapUnder()
    })

    $(pp + '-map-under-hide-btn').click(function () {
        hideMapUnder()
    })
}

function showMapUnder(): void {
    $(pp + '-map-under-box').show()

    $(pp + '-map-side-col').hide()

    $(pp + '-owners-col').removeClass('col-sm-8')
    $(pp + '-owners-col').addClass('col-sm-24')

    $(pp + '-map-under-show-btn').hide()
    $(pp + '-map-under-hide-btn').show()

    initMap(mapUnder, mapUnderId)
}

function hideMapUnder(): void {
    $(pp + '-map-under-box').hide()

    $(pp + '-map-side-col').show()

    $(pp + '-owners-col').addClass('col-sm-8')
    $(pp + '-owners-col').removeClass('col-sm-24')

    $(pp + '-map-under-show-btn').show()
    $(pp + '-map-under-hide-btn').hide()

    initMap(mapSide, mapSideId)
}

function initMap(mapVar, mapId): void {
    mapVar = $maps.initMap({
        mapElement: $('#' + mapId),
        mapId: mapId,
        mapOptions: {
            zoom: 14,
        },
    })

    $.each(locationsOther, function (idx, obj) {
        $maps.addMarker({
            image: $maps.markerCircleBlue,
            location: new google.maps.LatLng(obj.lat, obj.long),
            map: mapVar,
            mapId: mapId,
            no: 999 + idx,
            onOver: function () {
                $(pp + '-map-overlay').html(obj.rubrik)
                $(pp + '-map-overlay').show()
            },
            onOut: function () {
                $(pp + '-map-overlay').hide()
            },
            onClick: function () {
                $ajax.post({
                    url: '/Owner/CoordsModal',
                    data: {
                        lat: obj.lat,
                        lon: obj.long,
                    },
                    dataType: 'html',
                    success: function (res) {
                        $modal.show(res, true, true, true)
                    },
                })
            },
        })
    })

    $maps.addClustering({
        map: mapVar,
        mapId: mapId,
    })

    // add after clustering to exclude from cluster
    $.each(locationsThis, function (idx, obj) {
        $maps.addMarker({
            image: $maps.markerCircleRed,
            location: new google.maps.LatLng(obj.lat, obj.long),
            map: mapVar,
            mapId: mapId,
            no: idx,
            onOver: function () {
                $(pp + '-map-overlay').html(obj.rubrik)
                $(pp + '-map-overlay').show()
            },
            onOut: function () {
                $(pp + '-map-overlay').hide()
            },
            onClick: function () {
                if (obj.antal === 1) return
                $ajax.post({
                    url: '/Owner/CoordsModal',
                    data: {
                        lat: obj.lat,
                        lon: obj.long,
                    },
                    dataType: 'html',
                    success: function (res) {
                        $modal.show(res, true, true)
                    },
                })
            },
        })
    })

    $maps.zoomToFit({
        map: mapVar,
        mapId: mapId,
    })
}
